module.exports = __webpack_public_path__ + "static/media/Imagngmri.250bf760.svg";